// Cache Manager - Handles cache invalidation on tab close

import { useGameStore } from '@/stores/game'
import { useUtilitiesStore } from '@/stores/utilities'
import { clearThemeCache } from './themeLoader'

// Clear all caches
export function clearAllCaches(): void {
  // Clear theme cache
  clearThemeCache()
  
  // Clear game settings cache
  const gameStore = useGameStore()
  gameStore.clearGameSettings()
  
  // Clear countries cache
  const utilitiesStore = useUtilitiesStore()
  utilitiesStore.countriesLoaded = false
  utilitiesStore.countriesLoading = false
  utilitiesStore.countries = []
}

// Setup cache invalidation on tab close
export function setupCacheInvalidation(): void {
  window.addEventListener('pagehide', () => {
    clearAllCaches()
  })
  
  // Also use beforeunload as fallback
  window.addEventListener('beforeunload', () => {
    clearAllCaches()
  })
}

